import { intl } from './locale';

export default [
  {
    category: 'commonlyEvent',
    name: intl('CommonEvents'),
    eventList: [
      { name: 'onClick' },
      { name: 'onChange' },
      { name: 'onInput' },
      { name: 'onSelect' },
      { name: 'onSubmit' },
      { name: 'onReset' },
      { name: 'onFocus' },
      { name: 'onBlur' },
      { name: 'onScroll' },
      { name: 'onLoad' },
      { name: 'onError' },
    ],
  },
  {
    category: 'keybordEvent',
    name: intl('KeyboardEvents'),
    eventList: [{ name: 'onKeyDown' }, { name: 'onKeyPress' }, { name: 'onKeyUp' }],
  },
  {
    category: 'mouseEvent',
    name: intl('MouseEvents'),
    eventList: [
      { name: 'onDoubleClick' },
      { name: 'onDrag' },
      { name: 'onDragEnd' },
      { name: 'onDragEnter' },
      { name: 'onDragExit' },
      { name: 'onDragLeave' },
      { name: 'onDragOver' },
      { name: 'onDragStart' },
      { name: 'onDrop' },
      { name: 'onMouseDown' },
      { name: 'onMouseEnter' },
      { name: 'onMouseLeave' },
      { name: 'onMouseMove' },
      { name: 'onMouseOut' },
      { name: 'onMouseOver' },
      { name: 'onMouseUp' },
    ],
  },
  {
    category: 'animateEvent',
    name: intl('AnimationEvents'),
    eventList: [
      { name: 'onAnimationStart' },
      { name: 'onAnimationEnd' },
      { name: 'onAnimationItration' },
      { name: 'onTransitionEnd' },
    ],
  },
];
